import { reducers as articleReducers } from '@spp/redux-article';
import { reducers as spidReducers } from '@spp/redux-spid';
import { reducers as coreNavigationReducers } from '@spp/ui-core-navigation';

export { fetchLatestArticlesReducer as latestArticles } from './reducers/latest-articles';
export { fetchPlussArticlesReducer as plussArticles } from './reducers/pluss-articles';
export {
    fetchCollectionArticlesReducer as collectionArticles,
} from './reducers/collection-articles';
export { fetchRecirculationReducer as recirculation } from './reducers/recirculation';
export { deviceReducer as device } from './reducers/client-device';
export { fetchCouponCodesReducer as couponCodes } from './reducers/coupon-codes';
export { utmParamsReducer as utmParams } from './reducers/utm-params';
export { paywallTypeReducer as paywallType } from './reducers/paywall-type';
export { trackingReducer as loadedTrackers } from './reducers/tracking';

export { reducer as video } from '@spp/video-asset';

export const article = articleReducers.fetchArticle;
export const spid = spidReducers.spid;
export const coreNavigationUI = coreNavigationReducers.coreNavigationUI;



/** WEBPACK FOOTER **
 ** ./src/redux/reducers.js
 **/